export const THUMBNAIL = {
  projectAspectRatioClass: "aspect-[1/1]",
  projectAspectRatioString: "1 / 1",
  projectAspectRatio: 1 / 1,
  lessonAspectRatioClass: "aspect-[1/1]",
  lessonAspectRatioString: "1 / 1",
  lessonAspectRatio: 1 / 1,
} as const;

export const ITEM_LIMIT = {
  generalItemLimit: 10,
  gridCardItemLimitClass:
    "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-6 items-start",
  slideGridCardItemLimitClass:
    "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-6 items-start",
  listCardItemLimitClass: "flex flex-col gap-3 max-w-4xl",
};
